// Got from: http://stackoverflow.com/questions/17772260/textarea-auto-height
(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .directive('xxElastic', xxElastic);

    xxElastic.$inject = ['$timeout'];
    function xxElastic($timeout) {
        return { restrict: 'A', link: link };

        function link(scope, element, attrs, ctrl) {
            var initialHeight = element[0].style.height;
            element.on("input change", resize);
            $timeout(resize, 0);

            function resize() {
                element[0].style.height = initialHeight;
                element[0].style.height = element[0].scrollHeight + "px";
            };
        }
    }
})();
